import React, {Component} from "react";
import { strings } from "../localization";
import { TAG_USER_ROLES } from "../data/tags";

export default class TagRolesDropDown extends Component{

    renderOptions = () => {
        const options = [];

        for(let role in TAG_USER_ROLES){
            if(role === TAG_USER_ROLES.OWNER) continue;

            const label = strings[`tags_role_${TAG_USER_ROLES[role].toLowerCase()}_label`];

            options.push(<option key={role} value={role}>{label}</option>);
        }

        return options
    }

    getCurrentValue = () => {
        if(!this.props.value) return undefined;

        if(this.props.value === TAG_USER_ROLES.OWNER) return TAG_USER_ROLES.ADMIN;

        return this.props.value;
    }

    render(){
        const {onlyOptions = false, showOptionForAll = true, onChange = undefined} = this.props;

        const options = this.renderOptions();
        const value = this.getCurrentValue();

        return onlyOptions ? options : (
            <select disabled={this.props.disabled} className="tag-roles-dropdown" value={value} onChange={onChange} required>
                {showOptionForAll && <option value="" selected>{strings.tags_role_all_label}</option>}
                {this.renderOptions()}
            </select>);
    }
}